// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"237":"pages","409":"my","945":"dashboard"}[chunkId] || chunkId) + "-legacy." + {"237":"984e2356","409":"efbad833","779":"a708da06","945":"9fa4759e"}[chunkId] + ".js";
};